import type { ReactNode } from "react";

export const H1 = ({ children }: { children: ReactNode }) => {
  return (
    <h1 className="font-FKScreamer text-[72px] font-normal uppercase leading-[85%] text-[#0E0F0F] md:text-[96px]">
      {children}
    </h1>
  );
};
